import React, { Component } from 'react'
import GridedRow from '../GridedRow/GridedRow'
import { reduxForm, SubmissionError, Field } from 'redux-form'
import {fileInput, generalTextInput, wysiwygInput, AsyncAutoCompleteSelect} from '../FormFields/Fields'
import * as MabnaButton from '../Button/Button'
import { browserHistory } from 'react-router'
import { NotificationManager } from 'react-notifications'
import api from '../../../api/api'
import {
  CREATE_SUPPORT_TICKET_REQUEST,
  CREATE_SUPPORT_TICKET_REPLY_REQUEST,
  FETCH_SINGLE_SUPPORT_TICKET_REQUEST,
} from '../../../actions/actions'
import {createFormData} from '../../../helpers/utility'

const formSelectorName = 'AddSupportTicket'
const successMessage = 'تیکت شما با موفقیت ارسال شد'
const title = [
  'پشتیبانی',
  'پاسخ',
]

const isUserManager = (userType) => userType === 'MANAGER'

const loadReceiverOptions = (data, callback) => {
  api
    .getSupportReceiversList(`search=${data}`)
    .then(res => {
      const receivers = res.data.data.users

      return callback(receivers.map( (item) => {
        return {
          label: item.display_name,
          value: item.id,
        }
      }))
    })
    .catch(err => {
      console.log(err)
      return []
    })
}

const loadTicketTypesOptions = (data, callback) => {
  api.
    getSupportTicketTypes()
    .then(res => {
      const types = res.data.data.ticket_types

      return callback(
        types.map( item => {
          return {
            label: item.title,
            value: item.id,
          }
        })
      )
    })
    .catch(err => {
      console.log(err)
      return []
    })
}

class AddSuppotTicketForm extends Component {

  render() {
    const {
      handleSubmit,
      error,
      useAsEditForm,
      pristine,
      submitting,
      replyMode,
      userType,
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.reduxFormHandleSubmit)} className="create-update-form">
        <fieldset>
          <legend>{title[Number(replyMode)]}</legend>

          {isUserManager(userType) && !replyMode
            && this.renderReceiverAutoCompleteField()}

          {!replyMode && <GridedRow columns={2}>
            <Field
              name="title"
              title="عنوان"
              fieldName="title"
              component={generalTextInput}
              style={{width: '100%'}}
            />
          </GridedRow>}

            {/* {!replyMode && <GridedRow columns={2}>
              <Field
                name="ticket_type"
                title="نوع تیکت"
                fieldName="ticket_type"
                component={AutoCompleteSelect}
                isMulti={false}
                options={[
                  { id: 'support' , title: 'عمومی' },
                  { id: 'accounting' , title: 'مالی' },
                ]}
                style={{width: '100%'}}
              />
            </GridedRow>} */}

          {!replyMode && this.renderSupportTicketTypesField()}

          <GridedRow columns={1}>
            <Field
              name="text"
              title="توضیحات"
              fieldName="text"
              component={wysiwygInput}
            />
          </GridedRow>

          <GridedRow columns={2}>
            <Field
              name="attachment"
              title="فایل ضمیمه"
              fieldName="attachment"
              component={fileInput}
            />
          </GridedRow>

        </fieldset>

        <MabnaButton.Primary type="submit" disabled={submitting}>
          { submitting? 'در حال ارسال...' : 'ارسال' }
        </MabnaButton.Primary>
      </form>
    )
  }

  reduxFormHandleSubmit = formValues => {
    const { replyMode } = this.props

    if(replyMode) {
      return this.replyToSupportTicket(formValues)
    } else {
      return this.createSupportTicket(formValues)
    }
  }

  createSupportTicket = formValues => {
    const { dispatch, userType } = this.props
    const ticket_type = formValues.ticket_type && formValues.ticket_type.value
    const receiver = formValues.receiver && formValues.receiver.value
    const formData = createFormData({...formValues, ticket_type, receiver})

    return new Promise((resolve, reject) => {
      dispatch({
        type: CREATE_SUPPORT_TICKET_REQUEST,
        formData,
        userType,
        resolve,
        reject
      })
    }).then((result) => {
      NotificationManager.success(
        successMessage
      )
      this.supportTicketSubmitSuccessHandler()
    })
    .catch(errors => {
      throw new SubmissionError({
        _error: errors.general_errors[0],
        ...errors.form_errors
      })
    })
  }

  replyToSupportTicket = formValues => {
    const { dispatch, ticketCode, userType } = this.props

    const formData = createFormData(formValues)

    return new Promise((resolve, reject) => {
      dispatch({
        type: CREATE_SUPPORT_TICKET_REPLY_REQUEST,
        ticketCode,
        formData,
        userType,
        resolve,
        reject
      })
    }).then((result) => {
      NotificationManager.success(
        successMessage
      )
      this.supportTicketSubmitSuccessHandler()
    })
    .catch(errors => {
      throw new SubmissionError({
        _error: errors.general_errors[0],
        ...errors.form_errors
      })
    })
  }

  supportTicketSubmitSuccessHandler = () => {
    browserHistory.push(`/dashboard/support`)
  }

  supportTicketSubmitFailureHandler = () => {}

  renderReceiverAutoCompleteField = () => {
    return <GridedRow columns={2}>
      <Field
        title="گیرنده"
        fieldName="receiver"
        name="receiver"
        // component={AsyncReceivers}
        component={AsyncAutoCompleteSelect}
        loadOptions={loadReceiverOptions}
        noOptionsMessage={() => 'نام یا نام کاربری مرکز آموزشی یا دانش آموز مورد نظر را وارد نمایید'}
      />
    </GridedRow>
  }

  renderSupportTicketTypesField = () => {
    return <GridedRow columns={2}>
      <Field
        name="ticket_type"
        title="نوع تیکت"
        fieldName="ticket_type"
        component={AsyncAutoCompleteSelect}
        isMulti={false}
        loadOptions={loadTicketTypesOptions}
        defaultOptions
        style={{width: '100%'}}
        isSearchable={false}
        noOptionsMessage={() => 'موجود نیست'}
      />
    </GridedRow>
  }

}

const validate = (values, {replyMode}) => {
  let errors = {}

  if (!replyMode && !values.title) {
    errors.title = "عنوان الزامی است"
  }
  if (!values.text) {
    errors.text = "توضیحات الزامی است"
  }
  return errors
}

// Decorate the form component
AddSuppotTicketForm = reduxForm({
  form: formSelectorName,
  validate
})(AddSuppotTicketForm)

export default AddSuppotTicketForm



// WEBPACK FOOTER //
// ./src/components/common/Support/AddSupportTicketForm.js